<div class="modal-header">
    <h3 class="fw-semibold text-success mb-0 --bs-success">
        <i class="bi bi-box-seam me-2"></i>
        Caracterización - {{ empresa?.razonSocial }}
    </h3>
    <button
        type="button"
        class="btn-close"
        aria-label="Cerrar"
        (click)="activeModal.dismiss()"></button>
</div>
<div class="modal-body">
<div class="caracterizacion-container" style="text-align: left; font-family: Arial, sans-serif;">
    <div class="box-info" >
        <h4>Información de la Empresa</h4>
        <p style="margin: 5px 0;"><strong>NIT:</strong> {{ empresa?.nit }}</p>
        <p style="margin: 5px 0;"><strong>Razón Social:</strong> {{ empresa?.razonSocial }}</p>
        <p style="margin: 5px 0;"><strong>Tipo comercializador:</strong> {{ getTipoComercializador(caracterizacion?.tamanoComercializador) }}</p>
        <p style="margin: 5px 0;" *ngIf="caracterizacion?.fechaAsignacion">
            <strong>Fecha asignación:</strong> {{ caracterizacion.fechaAsignacion | date:'dd/MM/yyyy':'UTC' }}
        </p>
    </div>

    <div class="alert alert-warning" *ngIf="!tieneDatosCaracterizacionCompleta()">
        <i class="bi bi-exclamation-triangle"></i>
        <strong>Información parcial:</strong> Algunos datos de caracterización no están completos.
    </div>

    <div class="box" *ngIf="caracterizacion">
        <h4>Detalles de la Caracterización</h4>

        <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 15px;">
            <div class="info-group">
                <h5>Productos</h5>
                <p style="margin: 5px 0;"><strong>Grupos de Productos:</strong><br>{{ caracterizacion.gruposProductos ?? 'No registrado' }}</p>
            </div>

            <div class="info-group">
                <h5>Puntos de Venta</h5>
                <p style="margin: 5px 0;"><strong>Número de Puntos:</strong> {{ caracterizacion.puntosVenta }}</p>
                <p style="margin: 5px 0;"><strong>En Municipios:</strong> {{ caracterizacion.puntosVentaMunicipios }}</p>
                <p style="margin: 5px 0;"><strong>En Capitales:</strong> {{ caracterizacion.puntosVentaCapitales }}</p>
            </div>

            <div class="info-group">
                <h5>Personal</h5>
                <p style="margin: 5px 0;"><strong>Personal en Empresa:</strong> {{ caracterizacion.personalEmpresa }}</p>
                <p style="margin: 5px 0;"><strong>Clasificación:</strong> {{ caracterizacion.clasificacionPersonal }}</p>
            </div>

            <div class="info-group">
                <h5>Ventas</h5>
                <p style="margin: 5px 0;"><strong>Monto Promedio:</strong> {{ caracterizacion.montoPromedio }}</p>
                <p style="margin: 5px 0;"><strong>% Ventas Nacionales:</strong> {{ caracterizacion.porcentajeVentas }}</p>
                <p style="margin: 5px 0;"><strong>Puntos Venta Productos:</strong> {{ caracterizacion.puntosVentaProductos }}</p>
            </div>
        </div>
    </div>
</div>
</div>
<div class="modal-footer justify-content-center">
    <button
        type="button"
        class="btn btn-success"
        (click)="activeModal.close()">
        Cerrar
    </button>
</div>
